import React, { useEffect, useState } from 'react';
import { Button, Typography } from '@mui/material';

interface GuestCounterProps {
  initialAdults?: number;
  initialKids?: number;
  onGuestChange: (adults: number, kids: number) => void;
  storedPassengerDetail: any;
}

const GuestCounter: React.FC<GuestCounterProps> = ({ initialAdults, initialKids, onGuestChange, storedPassengerDetail }) => {
  const [adults, setAdults] = useState(storedPassengerDetail&&storedPassengerDetail?.passengerDetails ? storedPassengerDetail?.passengerDetails?.adults : 1) as any;
  const [kids, setKids] = useState(storedPassengerDetail&&storedPassengerDetail?.passengerDetails ? storedPassengerDetail?.passengerDetails?.kids : 0) as any;
  useEffect(() => {
    onGuestChange(adults, kids)
  }, [])

  const handleAdultIncrement = () => {
    const newAdults = adults + 1;
    setAdults(newAdults);
    onGuestChange(newAdults, kids);
  };

  const handleAdultDecrement = () => {
    const newAdults = adults > 1 ? adults - 1 : 1; // Ensuring adults never go below 1
    setAdults(newAdults);
    onGuestChange(newAdults, kids);
  };

  const handleKidIncrement = () => {
    const newKids = kids + 1;
    setKids(newKids);
    onGuestChange(adults, newKids);
  };

  const handleKidDecrement = () => {
    const newKids = kids > 0 ? kids - 1 : 0;
    setKids(newKids);
    onGuestChange(adults, newKids);
  };

  return (
    <div className="flex items-center justify-between border-2 border-red-500 rounded-full px-4 py-2 mt-4 w-full max-w-none">
      {/* Adults Section */}
      <div className="flex items-center">
        <Typography variant="body1" className="mr-2 text-sm md:text-base">Adults</Typography>
        <Button onClick={handleAdultDecrement} size="small" className="min-w-0 px-2">-</Button>
        <Typography variant="body1" className="mx-2 text-sm md:text-base">{adults}</Typography>
        <Button onClick={handleAdultIncrement} size="small" className="min-w-0 px-2">+</Button>
      </div>

      {/* Divider */}
      <div className="border-l-2 border-red-500 h-6 mx-4"></div>

      {/* Kids Section */}
      <div className="flex items-center">
        <Typography variant="body1" className="mr-2 text-sm md:text-base">Kids</Typography>
        <Button onClick={handleKidDecrement} size="small" className="min-w-0 px-2">-</Button>
        <Typography variant="body1" className="mx-2 text-sm md:text-base">{kids}</Typography>
        <Button onClick={handleKidIncrement} size="small" className="min-w-0 px-2">+</Button>
      </div>
    </div>

  );
}

export default GuestCounter;
